(function () {
  'use strict';

  angular.module('unit.deal.lead', ['ngResource']);
})();
